export const emailRule = new RegExp("^[\\.a-zA-Z0-9_-]+(\\+[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\\.[a-zA-Z]{1,}){1,2}$")
export const passwordRule = new RegExp("^.{4,160}$")
export const ERROR_MESSAGE = "Something wrong, please try again"
 